import React from 'react';
import { Box } from '@mui/material';

export default function PageSuspenseFallback({ fullPage }) {
  return (
    <Box sx={{ minHeight: fullPage ? '100vh' : '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box component="svg" role="status" aria-label="Loading" viewBox="0 0 48 48" width={48} height={48} sx={{ '& circle': { fill: 'none', strokeWidth: 4, strokeLinecap: 'round', transformOrigin: '24px 24px' } }}>
        <Box component="circle" cx="24" cy="24" r="20" pathLength="360" strokeDasharray="270 90" sx={{ stroke: (t) => t.palette.primary.main, animation: 'cm-spin 1.2s linear infinite' }} />
        <Box component="circle" cx="24" cy="24" r="12" pathLength="360" strokeDasharray="180 180" sx={{ stroke: (t) => t.palette.accent.cyan, animation: 'cm-spin-rev .9s linear infinite' }} />
      </Box>
    </Box>
  );
}
